import * as React from "react";
import styled, { css } from "styled-components";

export const SmartGradientColor = "linear-gradient(10deg, rgba(186,60,181,1)  0%,rgba(251,176,59,1) 100%)";

export const SmartGradientContainer = styled.div`
  ${() => css`
    background: rgb(251,176,59);
    background: linear-gradient(10deg, rgba(251,176,59,1) 0%, rgba(186,60,181,1) 100%);
  `}
`;
